import { CHINESE_KEYBOARD_NAME } from '../Custom/Chinese/constants';

export default {
  name: CHINESE_KEYBOARD_NAME.CANGJIE,
  layout: {
    default: [
      '· 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '手 田 水 口 廿 卜 山 戈 人 心 「 」 、',
      '日 尸 木 火 土 竹 十 大 中 ; \' {enter}',
      '{shift} 重 難 金 女 月 弓 一 , 。 / {shift}',
      '{special} {space} {@}',
    ],
    shift: [
      '~ ! @ # $ % …… & * ( ) —— + {bksp}',
      '手 田 水 口 廿 卜 山 戈 人 心 『 』 |',
      '日 尸 木 火 土 竹 十 大 中 : " {enter}',
      '{shift} 重 難 金 女 月 弓 一 《 》 ? {shift}',
      '{special} {space} {@}',
    ],
    special: [
      '. 1 2 3 4 5 6 7 8 9 0 < > {bksp}',
      '[ ] { } # % ^ * + = \\ | _',
      '- / : ; ( ) $ & @ \' ¥ {enter}',
      '… 。 , 、 ? ! ~ “ ” 「 」',
      '{default} {space} {@}',
    ],
  },
};
